import * as z from "zod";
import { mutator } from "./mutator";

// A UI-issued temporary credential that acts as the calling user. It lasts a
// single long workday and expires on its own; there is no refresh. This is the
// supported replacement for long-lived user API keys, which createApiKey no
// longer mints.
export const USER_SESSION_TTL_SECONDS = 16 * 60 * 60;

export const createUserSessionSchema = z.object({
  id: z.string(),
  start: z.string(),
  key: z.string(),
});

export const createUserSession = mutator({
  redactKeys: ["key"],
  schema: createUserSessionSchema,
  resolve: {},
  permissions: {
    none: "a user is always allowed to mint a credential that acts as themselves, with exactly their own access",
  },
  fn: async ({ tx, ctx, args: { id, start } }) => {
    const now = Date.now();
    await tx.mutate.apikey.insert({
      id,
      // The `usersession:` prefix marks this as a short-lived, UI-issued
      // credential so it's filtered out of the human-managed keys list.
      name: `usersession:${id}`,
      start,
      referenceId: ctx.userId,
      spaceId: null,
      serviceAccountId: null,
      enabled: true,
      expiresAt: now + USER_SESSION_TTL_SECONDS * 1000,
      createdAt: now,
      updatedAt: now,
      tenantId: ctx.tenantId,
    });
  },
});
